"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180.03 238.48",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("path", {
      d: "M80.2 204.55a112.87 112.87 0 01-54.63-14l-17 29.54a148.4 148.4 0 00143.19 0l-17-29.54a112.87 112.87 0 01-54.56 14z",
      fill: "#19B4FF"
    }), (0, _jsxRuntime.jsx)("path", {
      fill: "#1B1B1B",
      d: "M180.03 36V0c-15 0-21.91.92-26 2.78s-3.5 1.77-7.28 4.57c-3.46 2.55-9.3 8.65-13.07 12.84A80 80 0 0079.92.09C34.64.09-.02 34.75-.02 80.03c0 45 34.66 80.25 79.94 80.25 45 0 79.94-35.29 79.94-80.25a80.8 80.8 0 00-12.7-44h32.87zM79.94 126.56c-25.61 0-45.28-20.92-45.28-46.53S54.33 33.5 79.94 33.5c25.92 0 45 20.92 45 46.53s-19.09 46.53-45 46.53z"
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=LetterMark.js.map